module.exports = __webpack_public_path__ + "static/img/RSGUPS108_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RSGUPS108_1.png
// module id = vorP
// module chunks = 0